"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ConditionalHelper_1 = require("../helpers/ConditionalHelper");
var Query_1 = require("./Query");
var BaseQuery_1 = require("./BaseQuery");
var utils_1 = require("../utils");
var DocumentEntityQuery = /** @class */ (function (_super) {
    __extends(DocumentEntityQuery, _super);
    function DocumentEntityQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentEntityQuery.prototype.getOptions = function () {
        var _a = this.queryOptions.options, options = _a === void 0 ? {} : _a;
        return options.documentEntity;
    };
    DocumentEntityQuery.prototype.getRawValue = function (executionOptions) {
        var _a;
        var context = Query_1.Query.getContext(executionOptions, this.queryOptions);
        if (context) {
            var contextConfiguration = Query_1.Query.getContextConfiguration(executionOptions, this.queryOptions);
            var documentEntityKeysConfig = contextConfiguration.documentEntityKeys;
            var documentEntities = context.documentEntities, documentJoinMap = context.documentJoinMap, document_1 = context.document;
            var conditionalHelper = new ConditionalHelper_1.ConditionalHelper({ conditions: [] }, this.translationHelper);
            if (documentEntities && Object.keys(documentEntities).length === 0) {
                return;
            }
            // document context programmatically loaded by the app
            var documentClientCode = document_1.clientCode;
            // join map loaded into context by the API
            var entityClientCodes = (documentJoinMap && documentJoinMap[documentClientCode]) || [];
            // Config keys that would contain the conditions to filter the entities (user defined category)
            var options = this.getOptions();
            var optionsKeys = Object.keys(options);
            if (optionsKeys && optionsKeys.length > 0) {
                var queryOptionsType = optionsKeys[0];
                // Building up IQueryOptions due to options nesting for different queryOptionTypes that can be use to Query
                var entityQueryOptions = {
                    queryOptionsType: queryOptionsType,
                    options: options,
                };
                var documentEntityKeyGenerated = false;
                if (!options[queryOptionsType].documentEntityKey) {
                    options[queryOptionsType].documentEntityKey = utils_1.guid.generateGuid();
                    documentEntityKeyGenerated = true;
                }
                var documentEntityKey = options[queryOptionsType].documentEntityKey;
                // Load the query to fetch the data from the entity
                var query = new Query_1.Query(entityQueryOptions, this.translationHelper);
                var documentEntityByKeys = {};
                for (var _i = 0, entityClientCodes_1 = entityClientCodes; _i < entityClientCodes_1.length; _i++) {
                    var clientCode = entityClientCodes_1[_i];
                    var entity = documentEntities[clientCode];
                    if (entity) {
                        var documentEntityConfig = documentEntityKeysConfig && documentEntityKeysConfig[documentEntityKey];
                        var hasConfig = typeof documentEntityConfig === 'object';
                        if (!hasConfig && !documentEntityKeyGenerated) {
                            console.warn("Document Entity Query: documentEntityKey of \"" + documentEntityKey + "\" not found, using first document as fallback.");
                        }
                        var _b = documentEntityConfig || {}, conditional = _b.conditional, entityType = _b.entityType;
                        var valid = !conditional && !entityType;
                        if (valid && hasConfig && !documentEntityKeyGenerated) {
                            console.warn("Document Entity Query: documentEntityKey of \"" + documentEntityKey + "\" is found, but has no entityType or conditional defined. Using first document as fallback.");
                        }
                        if (!entityType || entityType === entity.type) {
                            valid = true;
                            if (conditional) {
                                // Build up conditional execution options to allow the query options instead of the dot notation when configuring
                                var conditionalExecutionOptions = __assign(__assign({}, executionOptions), { context: __assign(__assign({}, executionOptions.context), { entityByType: (_a = {},
                                            _a[entity.type] = entity,
                                            _a) }) });
                                valid = conditionalHelper.matches(entity, documentEntityConfig.conditional, conditionalExecutionOptions);
                            }
                        }
                        if (valid) {
                            documentEntityByKeys[documentEntityKey] = entity;
                            break;
                        }
                    }
                }
                var workingExecutionOptions = __assign(__assign({}, executionOptions), { context: __assign(__assign({}, executionOptions.context), { documentEntityByKeys: documentEntityByKeys }) });
                // Fire off the option query using new context
                return query.execute(workingExecutionOptions);
            }
        }
        return;
    };
    return DocumentEntityQuery;
}(BaseQuery_1.BaseQuery));
exports.DocumentEntityQuery = DocumentEntityQuery;
//# sourceMappingURL=DocumentEntityQuery.js.map